import "../../../../App.css"
import { useEffect, useState } from 'react';
import NavbarVerical from '../../../Navbar/navbarVertical';
import { Card, Form, Row, Col, Button, Table, Modal } from 'react-bootstrap';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getCourse, getStudentsByCourse,
  VerifyStudents, getStudentPhotosign, getStudentsAllData, getDocuments
} from "../../../api/bulkstudentverification";
import StudentBulkReport from "../../../Reports/StudentBulkReport";
import { PDFDownloadLink } from "@react-pdf/renderer";

function BulkStudentVerification() {
  const [selectedCourse, setSelectedCourse] = useState([]);
  const [courses, setCourses] = useState([]);
  const [error, setError] = useState('');
  const [studentByCourse, setstudentByCourse] = useState([]);
  const [studentBulkData, setStudentBulkData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isShowClicked, setIsShowClicked] = useState(false)
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [photos, setPhotos] = useState({});
  const [studentAllDataList, setStudentAllDataList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);

  const handleActiveChange = (e) => setIsActive(e.target.checked);
  const token =
    typeof window !== "undefined" ? localStorage.getItem("token") : null;
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [courseResponse] = await Promise.all([
          getCourse(token),
        ]);
        setCourses(courseResponse.data);
        console.log("Courses:", courseResponse.data);
      } catch (error) {
        setError("Error fetching data:", error);
        setStudentBulkData([]);
      }
    };
    fetchInitialData();
  }, [token]);

  const handleCoursechange = (event) => {
    setSelectedCourse(event.target.value);
    setIsShowClicked(false);
    setstudentByCourse([]);
  };

  const handleRowSelection = (studentId) => {
    if (!studentId) return;
    setSelectedRows((prev) =>
      prev.includes(studentId)
        ? prev.filter((id) => id !== studentId)
        : [...prev, studentId]
    );
  };

  const handleSelectAll = () => {
    if (isAllSelected) {
      setSelectedRows([]);
    } else {
  
      const allStudentIds = studentAllDataList.flatMap((item) =>
        item.data ? item.data.map((student) => student.student_id) : []
      );
      setSelectedRows(allStudentIds);
    }
    setIsAllSelected(!isAllSelected);
  };

  useEffect(() => {
    const allStudentIds = studentAllDataList.flatMap((item) =>
      item.data ? item.data.map((student) => student.student_id) : []
    );
    setIsAllSelected(
      allStudentIds.length > 0 &&
      allStudentIds.every((id) => selectedRows.includes(id))
    );
  }, [selectedRows, studentAllDataList]);

  
  const fetchStudentPhotoSign = async () => {
    try {
      const response = await getStudentPhotosign(token);
      const blob = await response.data; 
      const jsonData = await blobToJson(blob);

      console.log("Fetched Photo/Sign Data:", jsonData);

      const photoMap = {};

      await Promise.all(jsonData.map(async (item) => {
        try {
          if (!item.photo || !item.sign) {
            console.warn(`Missing photo or sign for student ID: ${item.userInfo.id}`);
            return;
          }

          // Detect content type dynamically
          const photoType = getImageFormat(item.photo) || "jpeg";
          const signType = getImageFormat(item.sign) || "jpeg";

          // Convert Base64 strings to Data URLs
          const photoBase64 = `data:image/${photoType};base64,${item.photo}`;
          const signBase64 = `data:image/${signType};base64,${item.sign}`;

          photoMap[item.userInfo.id] = {
            photo: photoBase64,
            sign: signBase64,
          };
        } catch (error) {
          console.error(`Error processing photo/sign for student ID: ${item.userInfo.id}`, error);
        }
      }));

      console.log("Mapped Photo and Sign:", photoMap);
      setPhotos(photoMap);
    } catch (error) {
      console.error("Error fetching student photo/sign:", error);
    }
  };

  const blobToJson = async (blob) => {
    const text = await blob.text();
    return JSON.parse(text);
  };

  const getImageFormat = (base64String) => {
    if (base64String.startsWith("/9j")) return "jpeg";
    if (base64String.startsWith("iVBOR")) return "png";
    if (base64String.startsWith("R0lG")) return "gif";
    if (base64String.startsWith("UklG")) return "webp";
    return null;
  };
  const handleShowClick = async () => {
    if (!selectedCourse) {
      toast.error("Please select a course before showing data.");
      return;
    }
    if (!dateFrom || !dateTo) {
      toast.error("Please select both 'From Date' and 'To Date' before showing data.");
      return;
    }
    try {
      const response = await getStudentsByCourse(selectedCourse, token);
      const allStudents = response.data;
      console.log("getStudentsByCourse:", allStudents);
      if (allStudents.length === 0) {
        toast.error("No students found for the selected course.");
        return;
      }
      const fromDate = new Date(dateFrom);
      const toDate = new Date(dateTo);
      const filteredStudents = allStudents.filter((student) => {
        const applicationDate = new Date(student.applicationDate);
        return applicationDate >= fromDate && applicationDate <= toDate;
      });
      console.log("Filtered Students by Date:", filteredStudents);
      if (filteredStudents.length === 0) {
        toast.error("No students found within the selected date range.");
        return;
      }
      setstudentByCourse(filteredStudents);
      const studentDataPromises = filteredStudents.map(async (student) => {
        const studentId = student.userInfo.id;
        const courseId = student.course.id;
        try {
          const studentAllDataResponse = await getStudentsAllData(studentId, courseId, token);
          console.log("Student Data Response by getStudentsAllData:", studentAllDataResponse.data);
          return { studentId, courseId, data: studentAllDataResponse.data };
        } catch (error) {
          console.error(`Error fetching data for studentId: ${studentId}, courseId: ${courseId}`, error);
          return null;
        }
      });
      const allStudentAllData = await Promise.all(studentDataPromises);
      const validData = allStudentAllData.filter((data) => data !== null);
      if (validData.length === 0) {
        toast.error("No student data available for the selected students and course.");
        return;
      }
      const inHouseFilteredData = validData.filter((student) =>
        student.data.some((dataItem) => dataItem.in_house === isActive)
      );
      if (inHouseFilteredData.length === 0) {
        toast.error("No data found for the selected In-House status.");
        return;
      }
      setStudentAllDataList(inHouseFilteredData);
      console.log("Final Fetched Student All Data (In-House Filtered):", inHouseFilteredData);
      const studentIds = filteredStudents.map((s) => s.userInfo.id);
      await fetchStudentPhotoSign(studentIds);
      setIsShowClicked(true);
      toast.success("Data fetched and filtered successfully.");
    } catch (error) {
      toast.error("Error fetching or filtering student data for the selected course and date range.");
    }
  };

  const handleVerify = async () => {
    if (selectedRows.length === 0) {
      toast.error("Please select at least one student to verify.");
      return;
    }
    const applicationNumbers = selectedRows.map(studentId => {
      const studentDetail = studentAllDataList
        .flatMap(studentItem => studentItem.data)
        .find(student => student.student_id === studentId);
      return studentDetail ? studentDetail.application_number : null;
    }).filter(Boolean);
    if (applicationNumbers.length === 0) {
      toast.error("No valid students selected for verification.");
      return;
    }
    try {
      const response = await VerifyStudents(token, applicationNumbers);
      console.log("Verify Response:", response);
      if (response.data && response.data.length > 0 && response.data[0].verify === true) {
        toast.success("Students verified successfully.");
        const updatedData = studentAllDataList.map(studentItem => {
          studentItem.data = studentItem.data.map(student => {
            if (selectedRows.includes(student.student_id)) {
              student.verified = true;
            }
            return student;
          });
          return studentItem;
        });
        setStudentAllDataList(updatedData);
      } else {
        toast.error("Failed to verify students.");
      }
    } catch (error) {
      console.error("Error verifying students:", error);
      toast.error("Error verifying students.");
    }
  };

  const courseId = Array.isArray(selectedCourse) ? selectedCourse[0]?.id : selectedCourse;
  useEffect(() => {
    const fetchStudentDocs = async () => {
      try {
        if (!selectedStudent || !selectedStudent?.student_id) {
          toast.error("Student ID is missing!");
          return;
        }
        if (!selectedCourse) {
          toast.error("Course ID is missing!");
          return;
        }
        const response = await getDocuments(selectedStudent.student_id, selectedCourse, token);
        if (response?.data?.length > 0) {
          setDocuments(response.data);
          console.log("fetchdocuments:", response.data);
        } else {
          toast.info("No documents found for the selected student and course.");
          setDocuments([]);
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
        toast.error("Failed to fetch documents.");
      }
    };
    if (selectedStudent) {
      fetchStudentDocs();
    }
  }, [selectedStudent, selectedCourse, token]);

  const handleViewDetails = (student) => {
    console.log("Selected student details:", student);
    setSelectedStudent(student);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedStudent(null);
  };
  const handleDownload = (documentData) => {
    try {
      // Ensure we have access to the DOM
      if (typeof document.createElement !== "function") {
        throw new Error("DOM is not available.");
      }
      if (!documentData || !documentData.documentFile) {
        toast.error("Document file is missing.");
        return;
      }
      const base64Data = documentData.documentFile;
      const sanitizedBase64 = base64Data.replace(/[\s\r\n]+/g, '');
      const byteCharacters = atob(sanitizedBase64);
      const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
      const byteArray = new Uint8Array(byteNumbers);
      const contentType = documentData.contentType || 'application/pdf';
      const blob = new Blob([byteArray], { type: contentType });
      const fileName = documentData.fileName || "downloaded_document.pdf";
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      // Clean up
      link.remove();
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Failed to download document. Check console for details.");
    }
  };
  const handleCancel = () => {
    setSelectedCourse('');
    setstudentByCourse([]);
    setSelectedRows([]);
    setStudentBulkData([]);
  };
  const selectedCourseName = courses.find(course => course.id === parseInt(selectedCourse))?.courseName || "";
  const applicationNumbers = selectedRows.map(
    (id) => studentByCourse.find((student) => student.id === id).applicationNumber
  );
  const registrationDate = selectedRows.map(
    (id) => studentByCourse.find((student) => student.id === id).applicationDate
  );
  const registrationNo = selectedRows.map(
    (id) => studentByCourse.find((student) => student.id === id).userInfo.id
  );

  const handleDownloadPDF = (studentDetail) => {
    const studentId = studentDetail.student_id;
    const photo = photos[studentDetail.student_id]?.photo;
    const sign = photos[studentDetail.student_id]?.sign;
    return (
      <PDFDownloadLink
        document={
          <StudentBulkReport
            student={studentDetail}
            photo={photo} sign={sign}
          />
        }
        fileName={`${studentDetail.student_id}_report.pdf`}
      >
        {({ loading }) => (loading ? "Preparing..." : "Download PDF")}
      </PDFDownloadLink>
    );
  };

  return (
    <>
      <NavbarVerical />
      <div className="content-area">
        <Card>
          <Card.Body>
            <p style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}>Bulk Student Verification</p>
            <Form>
              <Row className='mt-4'>
                <Col>
                  <Row className="mb-3">
                    <Form.Label
                      className="col-sm-3 col-form-label form-label" >
                      Course<span className="text-danger">*</span>
                    </Form.Label>
                    <Col sm={7} className="mb-3 mb-lg-0">
                      <Form.Select type="text"
                        placeholder="Enter Course"
                        id="  Course"
                        required
                        value={selectedCourse}
                        onChange={handleCoursechange}
                      >
                        <option value="">Select Course</option>
                        {courses.map((course) => (
                          <option key={course.id} value={course.id}>
                            {course.courseName}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Form.Label
                      className="col-sm-3 col-form-label form-label"
                    >
                      From Date<span className="text-danger">*</span>
                    </Form.Label>
                    <Col sm={4} className="mb-4 mb-lg-0">
                      <Form.Control
                        type="date"
                        id="mothertongue"
                        value={dateFrom}
                        onChange={(e) => setDateFrom(e.target.value)}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Form.Label
                      className="col-sm-3 col-form-label form-label"
                    >
                      To Date<span className="text-danger">*</span>
                    </Form.Label>
                    <Col sm={4} className="mb-4 mb-lg-0">
                      <Form.Control
                        type="date"
                        id="mothertongue"
                        value={dateTo}
                        onChange={(e) => setDateTo(e.target.value)}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Form.Label className="col-sm-3 col-form-label form-label">
                    </Form.Label>
                    <Col className="mt-2">
                      <Form.Check
                        type="switch"
                        id=" In House"
                        label=" In House"
                        checked={isActive}
                        onChange={handleActiveChange}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col></Col>
              </Row>

              <Row>
                <Col className="d-flex align-items-center justify-content-center mb-3">
                  <Button variant="primary" type="button"
                    onClick={handleShowClick}
                  >
                    Show
                  </Button>
                  <Button variant="primary" type="button" style={{ marginLeft: "10px" }}
                    onClick={handleVerify}
                  >
                    Verify
                  </Button>
                  <ToastContainer />
                  <Button variant="secondary" type="button" style={{ marginLeft: "10px" }}
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>

              <Row>
                <Table responsive striped bordered hover>
                  <thead>
                    <tr>
                      <th className="text-center align-top" style={{ width: "50px" }}>
                        <Form.Check
                          type="checkbox"
                          id="selectAll"
                          checked={isAllSelected}
                          onChange={handleSelectAll} />
                      </th>
                      <th>Registration No.</th>
                      <th>Student Name</th>
                      <th>Application No</th>
                      <th>Mobile No</th>
                      <th>Details</th>
                      <th>Preview Application</th>
                    </tr>
                  </thead>
                  <tbody>
                    {studentAllDataList.length > 0 ? (
                      studentAllDataList.map((studentItem, index) =>
                        studentItem.data?.map((studentDetail, detailIndex) => (
                          <tr key={`${index}-${detailIndex}`}>
                            <td className="text-center" style={{ width: "50px" }}>
                              <Form.Check
                                type="checkbox"
                                checked={selectedRows.includes(studentDetail?.student_id || "")}
                                onChange={() => handleRowSelection(studentDetail?.student_id || "")}
                              />
                            </td>
                            <td>{studentDetail?.student_id || "N/A"}</td>
                            <td>
                              {studentDetail?.first_name || "N/A"}{" "}
                              {studentDetail?.middle_name || ""}{" "}
                              {studentDetail?.last_name || ""}
                            </td>
                            <td>{studentDetail?.application_number || "N/A"}</td>
                            <td>{studentDetail?.student_mobile || "N/A"}</td>
                            <td>
                              <Button
                                variant="primary"
                                onClick={() => handleViewDetails(studentDetail)} // Open modal with details
                              >
                                View Details
                              </Button>
                            </td>
                            <td>
                              {handleDownloadPDF(studentDetail)}
                            </td>
                          </tr>
                        )) || (
                          <tr key={index}>
                            <td colSpan="7" style={{ textAlign: "center" }}>
                              No data available for this item.
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td colSpan="7" style={{ textAlign: "center" }}>
                          No data available to display.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Row>

              {/* Modal for Student Details */}
              <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                  <Modal.Title style={{ fontSize: 18 }}>Student Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {selectedStudent ? (
                    <>
                      {console.log('Selected Student:', selectedStudent)}
                      <div>
                        <p><strong>Registration No:</strong> {selectedStudent.student_id || "N/A"}</p>
                        <p><strong>Name:</strong> {`${selectedStudent.first_name || "N/A"} ${selectedStudent.middle_name || ""} ${selectedStudent.last_name || ""}`}</p>
                        <p><strong>Course Name:</strong> {selectedCourseName}</p>

                        <Table striped bordered hover>
                          <thead style={{ backgroundColor: "#6e48aa", color: "#fff" }}>
                            <tr>
                              <th style={{ fontSize: 15 }}>Document Name</th>
                              <th style={{ fontSize: 15 }}>Download</th>
                            </tr>
                          </thead>
                          <tbody>
                            {documents.length > 0 ? (
                              documents.map((doc, index) => (
                                <tr key={index}>
                                  <td>{doc.certificate.certificateName || "N/A"}</td>
                                  <td>
                                    <Button
                                      variant="link"
                                      onClick={() => handleDownload(doc)}
                                    >
                                      Download
                                    </Button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="2" style={{ textAlign: "center" }}>
                                  No documents available.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>

                      </div>
                    </>
                  ) : (
                    <p>No details available.</p>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseModal}>
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </>
  );
}

export default BulkStudentVerification;